module.exports = __webpack_public_path__ + "img/ic_fluent_data_line_24_regular.9e069b1f.svg";